export function toEd25519Wire(value: string): string {
  const v = value.trim();
  if (!v) return v;
  if (v.startsWith("base64://") || v.startsWith("file://")) return v;
  if (v.includes("-----BEGIN")) {
    return `base64://${btoa(v)}?type=pem`;
  }
  return `base64://${v.replace(/\s+/g, "")}?type=raw`;
}

export function pemToBase64Uri(pem: string): string {
  return `base64://${btoa(pem)}?type=pem`;
}

/** Ed25519 PKCS#8 private + SPKI public PEM, generated entirely in this browser. */
export async function generateKey() {
  const pair = await crypto.subtle.generateKey('Ed25519', true, ['sign', 'verify']) as CryptoKeyPair;
  const pem = (label: string, data: ArrayBuffer) => {
    const base64 = btoa(String.fromCharCode(...new Uint8Array(data)));
    return `-----BEGIN ${label}-----\n${base64.match(/.{1,64}/g)!.join('\n')}\n-----END ${label}-----\n`;
  };
  return {
    private_key_pem: pem('PRIVATE KEY', await crypto.subtle.exportKey('pkcs8', pair.privateKey)),
    public_key_pem: pem('PUBLIC KEY', await crypto.subtle.exportKey('spki', pair.publicKey)),
  };
}
